import {React, useState, useEffect, forwardRef, useRef, Fragment} from 'react';

import styles from './lineupmodal.module.css';
import constants from '../../../constants';

import { useApiProvider } from '../../../providers/ApiProvider';
import Select from '../Select/Select';

const LineupModal = forwardRef(function LineupDialog(props, ref) {

  const { isLoading, LoadingSpinner } = useApiProvider();
  const labelRef = useRef(null);

  const getOptions = (players) => {
    let sortedPlayers = players.sort((a, b) => a[constants.ranking] - b[constants.ranking]);
    const options = [{key: '', value: '', label: '', disabled: false}];

    sortedPlayers.map(p => {
      options.push({
        key: p[constants.playerId], 
        value: p[constants.playerId], 
        label: p[constants.firstName] + " " + p[constants.lastName],
        disabled: Object.values(props.players).includes(p[constants.playerId]),
      });
    });

    return options
  }
  
  const inputChange = (e) => {
    const playerPosition = e.currentTarget.id;
    const playerId = e.currentTarget.value;
    props.setPlayers(prev => ({ ...prev, [playerPosition]: playerId }));
  }

  const awayFemaleRows = [];
  for (let i = 1; i < 6; i++) {
    awayFemaleRows.push(
      <div className={styles.PlayerRow} key={`AwayFemalePlayer${i}`}>
        <label className={styles.Label}>{i}.</label>
        <Select
          id={`awayFemalePlayer${i}`}
          additionalStyle={styles.Select}
          currentValue={props.players[`awayFemalePlayer${i}`] ?? ''}
          onChange={inputChange}
          options={getOptions(props.awayFemales)}
        />
      </div>
    );
  }

  const homeFemaleRows = [];
  for (let i = 1; i < 6; i++) {
    homeFemaleRows.push(
      <div className={styles.PlayerRow} key={`HomeFemalePlayer${i}`}>
        <label className={styles.Label}>{i}.</label>
        <Select
          id={`homeFemalePlayer${i}`}
          additionalStyle={styles.Select}
          currentValue={props.players[`homeFemalePlayer${i}`] ?? ''}
          onChange={inputChange}
          options={getOptions(props.homeFemales)}
        />
      </div>
    );
  }

  const awayMaleRows = [];
  for (let i = 1; i < 6; i++) {
    awayMaleRows.push(
      <div className={styles.PlayerRow} key={`AwayMalePlayer${i}`}>
        <label className={styles.Label}>{i}.</label>
        <Select
          id={`awayMalePlayer${i}`}
          additionalStyle={styles.Select}
          currentValue={props.players[`awayMalePlayer${i}`] ?? ''}
          onChange={inputChange}
          options={getOptions(props.awayMales)}
        />
      </div>
    );
  }

  const homeMaleRows = [];
  for (let i = 1; i < 6; i++) {
    homeMaleRows.push(
      <div className={styles.PlayerRow} key={`HomeMalePlayer${i}`}>
        <label className={styles.Label}>{i}.</label>
        <Select
          id={`homeMalePlayer${i}`}
          additionalStyle={styles.Select}
          currentValue={props.players[`homeMalePlayer${i}`] ?? ''}
          onChange={inputChange}
          options={getOptions(props.homeMales)}
        />
      </div>
    );
  }

  return (
    <dialog ref={ref} className={styles.Dialog} style={{border: `5px solid ${props.loggedInTeam === constants.both ? constants.colors.cplNavy : props.teamColor}`}}>
      <div className={styles.Title} style={{backgroundColor: props.loggedInTeam === constants.both ? constants.colors.cplNavy : props.teamColor}}>
        {props.loggedInTeam === constants.both ? "Welcome Admin" : <Fragment>{props.dialogTitle}<img src={`/logos/${props.teamLogo}.png`} style={{height:'48px', width: '48px', marginLeft:'1em'}}/></Fragment>}
      </div>
      <div>
        <img className={styles.Close} onClick={props.closeDialog} src='/icons/close-blue.svg'></img><br/>
      </div>

      <div className={styles.SubTitle} style={{color:props.loggedInTeam === constants.both ? constants.colors.cplNavy : props.teamColor, borderBottom: `2px solid ${props.loggedInTeam === constants.both ? constants.colors.cplNavy : props.teamColor}`}}>
        {constants.labels.setLineup}
      </div>

      {!isLoading ? <div className={styles.Body}>

        {props.loggedInTeam === constants.both ? 
          <Fragment>
            <div className={styles.InputColumn}>
              <div className={styles.Header}>Away {constants.women}</div>
              {awayFemaleRows}
            </div>

            <div className={styles.InputColumn}>
              <div className={styles.Header}>Away {constants.men}</div>
              {awayMaleRows}
            </div>

            <div className={styles.InputColumn}>
              <div className={styles.Header}>Home {constants.women}</div>
              {homeFemaleRows}
            </div>

            <div className={styles.InputColumn}>
              <div className={styles.Header}>Home {constants.men}</div>
              {homeMaleRows}
            </div>
          </Fragment>
          :
          <Fragment>
            <div className={styles.InputColumn}>
              <div className={styles.Header}>{constants.women}</div>
              {props.loggedInTeam === constants.away ? awayFemaleRows : homeFemaleRows}
            </div>

            <div className={styles.InputColumn}>
              <div className={styles.Header}>{constants.men}</div>
              {props.loggedInTeam === constants.away ? awayMaleRows : homeMaleRows}
            </div>
          </Fragment>
        }

      </div> 
      : <LoadingSpinner/>}

      <div className={styles.ButtonArea}> 
        <button className={styles.SaveButton} onClick={props.onSave}>{constants.labels.saveLineup}</button>
      </div>

    </dialog>
  )
})

export default LineupModal;
